var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 75,
    width: 75,
    height: 75,
    transform: "rotate(-90 0 75)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48576 33.9386C0.518841 35.8768 0.495565 39.0425 2.43377 41.0094L34.0188 73.0623C35.957 75.0293 39.1227 75.0525 41.0897 73.1143C43.0566 71.1761 43.0799 68.0104 41.1416 66.0434L13.0661 37.552L41.5575 9.47643C43.5245 7.53822 43.5477 4.37248 41.6095 2.40556C39.6713 0.438631 36.5056 0.415355 34.5387 2.35357L2.48576 33.9386ZM74.0368 33.0001L6.03197 32.5001L5.95845 42.4999L73.9632 42.9999L74.0368 33.0001Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowDark);
export default __webpack_public_path__ + "static/media/backArrowDark.32ea64d9c445fb3005007aa8876eaddf.svg";
export { ForwardRef as ReactComponent };